import axios from "axios";
import { API_PATHS } from "../utils/constants/api.constants";

class ListManagementCost {
   
    static EditManagementCost(item) {
      const api = `${API_PATHS.Managementedit}`;
      const formData = new FormData();
  
      for (const key in item) {
        if (item.hasOwnProperty(key)) {
          formData.append(key, item[key]);
        }
      }
      return axios
        .post(api, formData, {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
        })
        .then((response) => response.data);
    }

  static UpdateManagementCost(item) {
        const api = `${API_PATHS.Managementupdate}`;
        const formData = new FormData();
        for (const key in item) {
          if (item.hasOwnProperty(key)) {
            formData.append(key, item[key]);
          }
        }
        return axios
        .post(api, formData, {
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            },
        })
        .then((response) => response.data);
  }

  static AddManagementCost(item) {
    const api = `${API_PATHS.ManagementCostAdd}`;
    // if caller passed a FormData instance, send it directly
    if (item instanceof FormData) {
      // send FormData and set multipart Content-Type
      return axios
        .post(api, item, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then((response) => response.data);
    }

    const formData = new FormData();

    for (const key in item) {
      if (item.hasOwnProperty(key)) {
        formData.append(key, item[key]);
      }
    }
    // send FormData with multipart Content-Type
    return axios
      .post(api, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then((response) => response.data);
  }

  static ListManagementCost(item) {
    const api = `${API_PATHS.ManagementCostList}`;
    const formData = new FormData();
    for (const key in item) {
      if (item.hasOwnProperty(key)) {
        formData.append(key, item[key]);
      }
    }
    return axios
      .post(api, formData, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      })
      .then((response) => response.data);
  }

  static UpdateManagementCostMC(item) {
    const api = `${API_PATHS.ManagementCostUpdate}`;
    // If caller provided a FormData instance, send it directly so files/boundary are preserved
    if (item instanceof FormData) {
      return axios
        .post(api, item, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then((response) => response.data);
    }

    const formData = new FormData();
    for (const key in item) {
      if (item.hasOwnProperty(key)) {
        formData.append(key, item[key]);
      }
    }
    return axios
      .post(api, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then((response) => response.data);
  }

  static GetManagementCostDetail(item) {
    const api = `${API_PATHS.ManagementCostDetail}`;
    const formData = new FormData();
    for (const key in item) {
      if (item.hasOwnProperty(key)) {
        formData.append(key, item[key]);
      }
    }
    return axios
      .post(api, formData, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      })
      .then((response) => response.data);
  }


  static EditComapnyDucuments(item) {
    const api = `${API_PATHS.ComapnyDucumentsedit}`;
    const formData = new FormData();

    for (const key in item) {
      if (item.hasOwnProperty(key)) {
        formData.append(key, item[key]);
      }
    }
    return axios
      .post(api, formData, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      })
      .then((response) => response.data);
  }

  static UpdateComapnyDucuments(item) {
    const api = `${API_PATHS.ComapnyDucumentsUpdate}`;
    if (item instanceof FormData) {
      return axios
        .post(api, item, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then((response) => response.data);
    }

    const formData = new FormData();
    for (const key in item) {
      if (item.hasOwnProperty(key)) {
        formData.append(key, item[key]);
      }
    }
    return axios
      .post(api, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then((response) => response.data);
}

  static AddManagementCostHead(item) {
    const api = `${API_PATHS.ManagementHeadAdd}`;
    const formData = new FormData();

    for (const key in item) {
      if (item.hasOwnProperty(key)) {
        formData.append(key, item[key]);
      }
    }
    return axios
      .post(api, formData, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      })
      .then((response) => response.data);
  }

  static ListManagementCostHead(params) {
    const api = `${API_PATHS.ManagementHeadList}`;
    const formData = new FormData();
    for (const key in params) {
      if (params.hasOwnProperty(key)) {
        formData.append(key, params[key]);
      }
    }
    return axios
      .post(api, formData, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      })
      .then((response) => response.data);
  }

  static GetManagementCostHeadDetail(item) {
    const api = `${API_PATHS.ManagementHeadDetail}`;
    const formData = new FormData();
    for (const key in item) {
      if (item.hasOwnProperty(key)) {
        formData.append(key, item[key]);
      }
    }
    return axios
      .post(api, formData, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      })
      .then((response) => response.data);
  }

  static UpdateManagementCostHead(item) {
    const api = `${API_PATHS.ManagementHeadUpdate}`;
    const formData = new FormData();
    for (const key in item) {
      if (item.hasOwnProperty(key)) {
        formData.append(key, item[key]);
      }
    }
    return axios
      .post(api, formData, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      })
      .then((response) => response.data);
  }

  static DeleteManagementCostHead(item) {
    const api = `${API_PATHS.ManagementHeadDelete}`;
    const formData = new FormData();
    for (const key in item) {
      if (item.hasOwnProperty(key)) {
        formData.append(key, item[key]);
      }
    }
    return axios
      .post(api, formData, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      })
      .then((response) => response.data);
  }


      

}

export default ListManagementCost;